import React, { useCallback, useState } from 'react'
import PartnerProfileDialog from '../components/PartnerProfileDialog'
import type { PartnerProfile } from './usePartnerShared'

interface Target {
	id: string
	fallback?: Partial<PartnerProfile> | null
}

/**
 * The state every partner list needs to open the profile popup (MYD-533).
 *
 *   const { openPartner, partnerDialog } = usePartnerProfileDialog()
 *   <button onClick={() => openPartner(user._id, user)}>…</button>
 *   {partnerDialog}
 *
 * `fallback` is whatever the list already has on the person, shown at once
 * and kept if they are not one of the viewer's partners.
 */
export function usePartnerProfileDialog() {
	const [target, setTarget] = useState<Target | null>(null)

	const openPartner = useCallback((id: string | null | undefined, fallback?: Partial<PartnerProfile> | null) => {
		if (id) setTarget({ id: String(id), fallback })
	}, [])

	const partnerDialog = (
		<PartnerProfileDialog
			partnerUserId={target?.id ?? null}
			fallback={target?.fallback}
			onClose={() => setTarget(null)}
		/>
	)

	return { openPartner, partnerDialog }
}

export default usePartnerProfileDialog
